// Runmode NR系コンポーネントMixins

import runmode from "@/mixin/runmode";
import lodash from "lodash";
import * as constants from "@/mixin/constants";

export default {
  data() {
    return {
      // 表示ACT配列
      dispActBlockList: [],
      // 正解act index
      correctIndex: [],
      // 不正解act index
      incorrectIndex: [],
      // 選択中のrunmode
      runmode: "",
      // 問題音声再生中フラグ
      isAudioQuestionPlaing: false,
      // 完了ACTindex
      finishActIndex: [],
      // 正解画像表示フラグ
      showCorrectImg: false,
      // 不正解画像表示フラグ
      showIncorrectImg: false,
      // 不正解表示制御タイマー
      inncorectTimer: null,
      // 正解音再生中
      isCorrectPlaying: false,
      // 不正解音再生中
      isIncorrectPlaying: false,
      // 次ACT一時停止
      stopNextAct: false,
      // 次ACT表示タイマー
      nextTimer: null,
      // 開始待ち
      waitingStart: false,
      // 自動調整設定
      cardAreaHeight: 0,
      cardAreaFontSize: 0
    };
  },
  mixins: [
    runmode
  ],
  computed: {
    sreUse: function() {
      return this.$store.getters.sreUse;
    },
    nrStyles: function() {
      return {
        "--cardAreaHeight": String(this.cardAreaHeight) + "px",
        "--cardAreaFontSizePx": String(this.cardAreaFontSize) + "px",
        "--cardAreaFontSizeRem": String(this.cardAreaFontSize / 10) + "rem"
      }
    }
  },
  mounted() {
    const MAX_AUTO_ADJUST_FONT_SIZE = constants.AUTO_ADJUST_FONT_SIZE[this.textSize].max;
    this.cardAreaFontSize = MAX_AUTO_ADJUST_FONT_SIZE;
  },
  methods: {
    isActActive: function(index) {
      // ACTがアクティブかチェック
      return index === this.currentActIndex;
    },
    getThumbPath: function(index, img_path) {
      // 背景画像のスタイル取得
      if (this.pathstep.acts[index - 1] && this.pathstep.acts[index - 1].group === this.pathstep.acts[index].group) {
        // 前のACTとグループが同じ場合、サムネイル非表示
        return {};
      } else {
        // サムネイル表示
        return {
          "background-image": "url(" + img_path + ")"
        };
      }
    },
    showAnswerLabel: function(index) {
      // 正解表示
      if (!this.isChallenge(this.pathstep.acts[index])) {
        // 回答なし
        return true;
      } else {
        // 回答なし
        if (_.includes(this.finishActIndex, index)) {
          // 回答済み
          return true;
        } else {
          // 未回答
          return false;
        }
      }
    },
    showAnswerLabelNR3: function(index) {
      // NR3系正解表示
      if (this.sreUse == "false") {
        // 音声認識無効
        return true;
      } else {
        return this.showAnswerLabel(index);
      }
    },
    disableReplayButton: function(index) {
      // オーディオ再生ボタン非活性
      return this.audioPlaying || !this.enableAudioReplay;
    },
    isShowCorrectImg: function(index) {
      // 正解画像表示制御
      return this.isActActive(index) && this.showCorrectImg;
    },
    isShowIncorrectImg: function(index) {
      // 不正解画像表示制御
      return this.isActActive(index) && this.showIncorrectImg;
    },
    getLangText: function(act) {
      // テキスト取得
      if (this.dispJapaneseStatus == true) {
        // 日本語表示
        return act.japaneseText;
      } else {
        // 英語
        return act.basicText;
      }
    },
    getQuestionBlankText: function(act) {
      // 問題の空欄部分のテキスト取得
      if (this.dispAllAnswerStatus || this.dispJapaneseStatus) {
        // 回答表示または日本語表示の場合
        return this.getLangText(act);
      } else {
        return "";
      }
    },
    getNRFontSize: function(act) {
      // 言語によるフォントサイズ取得（吹き出し）
      if (this.dispJapaneseStatus == true) {
        // 日本語表示
        return this.getTextFontSizeNRFJP(act.japaneseText);
      } else {
        // 英語表示
        return this.getTextFontSizeNRF(act.basicText);
      }
    },
    getNRSelectFontSize: function(act) {
      // 選択肢フォントサイズ取得
      if (this.dispJapaneseStatus == true || this.runmode == constants.RUNMODE_NR1) {
        // 日本語表示
        return this.getTextFontSizeNRJP(act.japaneseText);
      } else {
        // 英語表示
        return this.getTextFontSizeNR(act.basicText);
      }
    },
    // NR系テキストフォントサイズ取得
    getTextFontSizeNR: function(text) {
      var replaceText = text.replace(/<.+?>/g, "");
      var textLength = replaceText.length;
      if (textLength <= 25) {
        return "font28";
      } else if (textLength <= 35) {
        return "font24";
      } else if (textLength <= 60) {
        return "font21";
      } else if (textLength <= 75) {
        return "font18";
      } else {
        return "font15";
      }
    },
    // NR系日本語テキストフォントサイズ取得
    getTextFontSizeNRJP: function(text) {
      var replaceText = text.replace(/<.+?>/g, "");
      var textLength = replaceText.length;
      if (textLength <= 12) {
        return "font28";
      } else if (textLength <= 16) {
        return "font24";
      } else if (textLength <= 19) {
        return "font21";
      } else if (textLength <= 32) {
        return "font18";
      } else {
        return "font15";
      }
    },
    // NR系テキスト吹出フォントサイズ取得
    getTextFontSizeNRF: function(text) {
      var replaceText = text.replace(/<.+?>/g, "");
      var textLength = replaceText.length;
      if (textLength <= 118) {
        return "font28";
      } else if (textLength <= 212) {
        return "font24";
      } else if (textLength <= 241) {
        return "font21";
      } else if (textLength <= 283) {
        return "font18";
      } else {
        return "font15";
      }
    },
    // NR系日本語テキスト吹出フォントサイズ取得
    getTextFontSizeNRFJP: function(text) {
      var replaceText = text.replace(/<.+?>/g, "");
      var textLength = replaceText.length;
      if (textLength <= 66) {
        return "font28";
      } else if (textLength <= 78) {
        return "font24";
      } else if (textLength <= 132) {
        return "font21";
      } else if (textLength <= 156) {
        return "font18";
      } else {
        return "font15";
      }
    },
    /**
     * カード領域自動サイズ調整処理
     */
    autoAdjustCardArea: function() {

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      let cardClone;
      let textAreaClone;
      let textClone;
      const cloneCard = function(targetText) {
        // カードを複製
        cardClone = $("#js-nr-acts > div > .flexbox:first").clone();
        let baseClone = cardClone.children(".answer").children("._item");
        let isBlank = baseClone.children("p").length == 0;
        textAreaClone = isBlank ? baseClone.children(".q-blank").children("p") : baseClone.children("p");
        textClone = textAreaClone.children("span");
        // 複製した要素にテキストを設定してDOMに追加
        textAreaClone.css("cssText", "height: auto;");
        textClone.html(targetText);
        cardClone.appendTo("#js-nr-acts > div");
      };

      // 高さを取得
      const getAutoAdjustHeight = function(targetText, fixedHeight, fixedFontSize) {
        let result = fixedHeight;

        // カードを複製
        cloneCard(targetText);

        // 確定したフォントサイズを設定
        textClone.css({ fontSize: fixedFontSize });

        // カードの高さを確定させる
        let textAreaHeight = textAreaClone.outerHeight();
        if (fixedHeight < textAreaHeight) {
          result = textAreaHeight;
        }

        // DOMに追加した複製要素を削除
        cardClone.remove();

        // 確定したサイズを返す
        return result;
      };

      // カードのフォントサイズを求める
      for (let act of this.pathstep.acts) {
        // 英語で実施
        cloneCard(act.basicText);
        this.usCardAreaFontSize = this.getAutoAdjustFontSize(textAreaClone, textClone, this.usCardAreaFontSize);
        cardClone.remove();
        // 日本語で実施
        cloneCard(act.japaneseText);
        this.jpCardAreaFontSize = this.getAutoAdjustFontSize(textAreaClone, textClone, this.jpCardAreaFontSize);
        cardClone.remove();
      }
      // カードの高さを求める
      for (let act of this.pathstep.acts) {
        // 英語で実施
        this.usCardAreaHeight = getAutoAdjustHeight(act.basicText, this.usCardAreaHeight, this.usCardAreaFontSize);
        // 日本語で実施
        this.jpCardAreaHeight = getAutoAdjustHeight(act.japaneseText, this.jpCardAreaHeight, this.jpCardAreaFontSize);
      }
    },
    /**
     * カード領域サイズ適用
     */
    applyCardAreaSize: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      let fixedSize = this.getAutoAdjustFixedSize();
      this.cardAreaHeight = fixedSize.cardAreaHeight;
      this.cardAreaFontSize = fixedSize.cardAreaFontSize;
    },
    /**
     * 自動調整初期処理
     */
    initAutoAdjustNR: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // 自動調整初期処理
      this.initAutoAdjust([".page-content"], [".page-content"]);
    },
    /**
     * 自動調整での最初の表示処理
     */
    autoAdjustFirstShownNR: function() {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // 表示領域自動調整
      let funcs = [this.autoAdjustCardArea, this.applyCardAreaSize];
      this.autoAdjustFirstShown(funcs, [".page-content"]);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/runmode_nr.js